import {CustomModal} from '_metronic/partials/modals/CustomModal'
import MultiSelect from 'app/pages/trust/components/MultiSelect'
import React, {useEffect, useState} from 'react'
import {useAuth} from 'app/modules/auth'
import cloudService from '../../services/cloud.services'
import { showErrorToast, showSuccessToast } from 'app/components/ShowToast'

interface CloudData {
    id: string
    type: string
    purpose: string
    name: string
    account_id: string
    severity: string
    open_issues: string
    ignored: string
    last_scanned: any
    created_at: any
    scan_results?: any[]
    excluded_categories?: string[]
  }

const ExcludeCategoryModal = ({
  isOpen,
  onClose,
  categories,
  cloud,
  onUpdated,
}: {
  isOpen: boolean
  onClose: () => void
  categories: string[]
  cloud: CloudData
  onUpdated?: (excluded: string[]) => void
}) => {
  const [selectedCategories, setSelectedCategories] = useState<string[]>([])
  const {currentUser} = useAuth()
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    if (isOpen) {
      setSelectedCategories(cloud.excluded_categories || [])
    }
  }, [isOpen, cloud])

  const toggleCategories = (category: string) => {
    if (selectedCategories.includes(category)) {
      setSelectedCategories(selectedCategories.filter((c) => c !== category))
    } else {
      setSelectedCategories([...selectedCategories, category])
    }
  }
  const removeCategory = (category: string) => {
    setSelectedCategories(selectedCategories.filter((c) => c !== category))
  }
  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      title='Exclude Category'
      isCloseIconShown={true}
      okBtnText='Exclude'
      okBtnClickHandler={async () => {
        if (!currentUser?.tenantId || !cloud?.id) return
        try {
          setLoading(true)
          await cloudService.updateCloud(currentUser.tenantId, cloud.id, {
            excluded_categories: selectedCategories,
          })
          showSuccessToast({message: 'Excluded categories updated successfully.'})
          onUpdated && onUpdated(selectedCategories)
          onClose()
        } catch (e) {
          console.error('Failed to update excluded categories', e)
          showErrorToast({message: 'Failed to update excluded categories.'})
        } finally {
          setLoading(false)
        }
      }}
      isLoading={loading}
      isLoadingBtnText={`Excluding...`}
    >
      <MultiSelect
        label='Categories'
        placeholder='Select Categories'
        options={categories.map((category) => ({id: category, title: category}))}
        selectedList={selectedCategories}
        toggleList={toggleCategories}
        removeItem={removeCategory}
      />
    </CustomModal>
  )
}

export default ExcludeCategoryModal
